// ═══ 데스크톱(≥1024) 회사명 드롭다운 — 탭에서 빠진 '더보기' 를 흡수한다 (신고 371 §8 결정 3) ═══
// 시안 C1 `.menu` (290px, 앱바 우측 앵커). 행 = 언어 · 차량관리 화면으로 보기 · 앱 안내 · 로그아웃.
// 동작은 screens/SimpleMore.js 와 **같은 함수**를 쓴다(확인 시트 포함) — v2/simple/moreActions.js.
// props: { user, screenMode, onLogout }
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, R, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import ConfirmSheet from './ConfirmSheet';
import Glyph from './Glyph';
import LangSelect from './LangSelect';
import LtrText from './LtrText';
import { APP_STORE, PLAY_STORE, goFullMode, logoutSimple } from '../moreActions';

// 회사 이니셜 — 영문명이 있으면 두 글자, 없으면 한 글자.
export function initialsOf(name) {
  var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '-';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

var menu = { position: 'absolute', top: 'calc(100% + 8px)', insetInlineEnd: 0, width: 290, minWidth: 260, zIndex: 70,
  background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, boxShadow: T.shadowMenu,
  overflow: 'clip', color: T.ink, textAlign: 'start' };
var head = { display: 'flex', alignItems: 'center', gap: 9, padding: '11px 14px',
  borderBottom: '1px solid ' + T.bdSoft, background: T.head, minWidth: 0 };
var headAv = { width: 30, height: 30, borderRadius: R.md, flex: 'none', display: 'grid', placeItems: 'center',
  direction: 'ltr', background: 'linear-gradient(135deg,' + T.navy + ',' + T.accent + ')', color: T.card,
  fontSize: 11, fontWeight: 800 };
var headTx = { minWidth: 0 };
var headName = { display: 'block', fontSize: 12.5, fontWeight: 800, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var headSub = { display: 'block', fontSize: 11, color: T.faint, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
// border 는 단축만 — 변형끼리 키 집합이 같아야 React 가 스타일을 지우지 않는다(theme.js 주석 규칙).
var row = { display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 14px',
  border: 0, borderBottom: '1px solid ' + T.bdSoft, fontSize: 12.5, color: T.body, background: 'none',
  textAlign: 'start', fontFamily: 'inherit', minWidth: 0 };
var rowBtn = Object.assign({}, row, { cursor: 'pointer' });
var rowLast = Object.assign({}, row, { cursor: 'pointer', borderBottom: 0 });
var glyph = { color: T.muted, flex: 'none', display: 'flex' };
var tx = { flex: 1, minWidth: 0 };
// 행 라벨은 자르지 않는다 — ar('معلومات التطبيق')은 링크 2개와 같은 행이라 한 줄에 안 들어간다 (D6).
var t1 = { display: 'block', fontSize: 12.5, fontWeight: 700, color: T.ink, whiteSpace: 'normal', lineHeight: 1.35 };
var t2 = { display: 'block', fontSize: 11, color: T.faint, marginTop: 1, whiteSpace: 'normal', lineHeight: 1.35 };
var right = { marginInlineStart: 'auto', display: 'flex', alignItems: 'center', gap: 6, flex: 'none' };
var linkBtn = { display: 'inline-flex', alignItems: 'center', height: 26, padding: '0 9px', borderRadius: R.md,
  border: '1px solid ' + T.accentBd, background: T.card, color: T.accentPress, fontSize: FONT.label, fontWeight: 700,
  textDecoration: 'none', whiteSpace: 'nowrap' };

function Chevron() {
  return (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M5.5 9l6.5 6.5L18.5 9" /></svg>);
}

function WhoMenu(props) {
  var t = useT();
  var navigate = useNavigate();
  var user = props.user || {};
  var st = useState(false);
  var open = st[0], setOpen = st[1];
  var st2 = useState('');
  var sheet = st2[0], setSheet = st2[1];
  var boxRef = useRef(null);

  var companyName = user.companyNameEn || user.companyName || user.name || '';

  // 바깥 클릭·ESC 로 닫힘 — 열려 있을 때만 건다.
  useEffect(function () {
    if (!open) return undefined;
    var onDown = function (e) {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    var onKey = function (e) { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return function () {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
    // setOpen 은 useState 가 보장하는 안정 참조 — 배열 구조분해라 린터가 못 알아본다.
  }, [open, setOpen]);

  var goFull = function () { setSheet(''); goFullMode(props.screenMode, navigate); };
  var doLogout = function () { setSheet(''); logoutSimple(props.onLogout, navigate); };

  return (<div className="ss-whowrap" ref={boxRef}>
    <button type="button" className={'ss-who ss-who-btn' + (open ? ' on' : '')} data-testid="ss-who-btn"
      aria-haspopup="true" aria-expanded={open ? 'true' : 'false'}
      onClick={function () { setOpen(!open); }}>
      <span className="ss-av">{initialsOf(companyName)}</span>
      <span dir="ltr" className="ss-who-name">{companyName}</span>
      <Chevron />
    </button>

    {open ? (<div className="ss-menu" role="menu" style={menu}>
      <div style={head}>
        <span style={headAv}>{initialsOf(companyName)}</span>
        <span style={headTx}>
          <LtrText style={headName}>{companyName}</LtrText>
          <LtrText style={headSub}>{user.name || ''}</LtrText>
        </span>
      </div>

      <div className="ss-mrow" style={row}>
        <span style={glyph}><Glyph id="translate" /></span>
        <span style={tx}><span style={t1}>{t('settingsLanguage')}</span></span>
        <span style={right}><LangSelect variant="row" /></span>
      </div>

      <button type="button" className="ss-mrow" style={rowBtn} onClick={function () { setOpen(false); setSheet('full'); }}>
        <span style={glyph}><Glyph id="apps" /></span>
        <span style={tx}>
          <span style={t1}>{t('simpleShowAll')}</span>
          <span style={t2}>{t('simpleShowAllSub')}</span>
        </span>
      </button>

      <div className="ss-mrow" style={row}>
        <span style={glyph}><Glyph id="info" /></span>
        <span style={tx}><span style={t1}>{t('moreAppInfo')}</span></span>
        <span style={right}>
          <a style={linkBtn} href={APP_STORE} target="_blank" rel="noreferrer">App Store</a>
          <a style={linkBtn} href={PLAY_STORE} target="_blank" rel="noreferrer">Google Play</a>
        </span>
      </div>

      <button type="button" className="ss-mrow" style={Object.assign({}, rowLast, { color: T.danger })}
        onClick={function () { setOpen(false); setSheet('logout'); }}>
        <span style={Object.assign({}, glyph, { color: T.danger })}><Glyph id="power" /></span>
        <span style={tx}><span style={Object.assign({}, t1, { color: T.danger })}>{t('settingsProfileLogout')}</span></span>
      </button>
    </div>) : null}

    <ConfirmSheet open={sheet === 'full'} title={t('simpleB1ShowAllSheetTitle')}
      headline={t('simpleB1SheetFullHeadline')} sub={t('simpleB1SheetFullSub')} hint={t('simpleShowAllHint')}
      confirmLabel={t('simpleShowAll')} onConfirm={goFull} onClose={function () { setSheet(''); }} />
    <ConfirmSheet open={sheet === 'logout'} title={t('settingsProfileLogout')}
      confirmLabel={t('settingsProfileLogout')} onConfirm={doLogout} onClose={function () { setSheet(''); }} />
  </div>);
}

export default WhoMenu;
